module.exports = __webpack_public_path__ + "img/ho-subline.9ed99137.jpg";